import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Marcos R.',
  location: 'Buenos Aires',
  text: 'Detecté el kilometraje adulterado en 10 minutos con el Bono 3. Me retiré y encontré otro auto en dos días.',
  color: 'bg-electric'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  location: 'Córdoba',
  text: 'Bajé el precio $150.000 en una sola conversación usando la plantilla de negociación del Bono 4.',
  color: 'bg-silver'
}, {
  initials: 'JP',
  name: 'Javier P.',
  location: 'Rosario',
  text: 'El Tomo 6 me salvó de comprar un auto con prenda activa de $400.000. No lo hubiera detectado solo.',
  color: 'bg-gold'
}];
export function Testimonials() {
  return <section className="pt-16 pb-12 border-b border-petroleum bg-graphite/50" data-id="element-494">
      <div className="container mx-auto px-4" data-id="element-495">
        {/* Social Proof Header */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mb-10 flex justify-center" data-id="element-496">
          <div className="inline-flex items-center gap-4 md:gap-6 bg-petroleum/80 backdrop-blur-sm border border-electric/20 rounded-full pl-3 pr-5 md:pl-4 md:pr-7 py-2.5 md:py-3 shadow-lg shadow-electric/5" data-id="element-497">
            {/* Avatars */}
            <div className="flex -space-x-2.5" data-id="element-498">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-electric/30 to-petroleum border-2 border-petroleum flex items-center justify-center text-[11px] md:text-xs font-bold text-white" data-id="element-499">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>

            {/* Divider */}
            <span className="w-px h-8 md:h-9 bg-gradient-to-b from-transparent via-electric/30 to-transparent" data-id="element-500"></span>

            {/* Rating */}
            <div className="flex flex-col items-start leading-tight" data-id="element-501">
              <div className="flex items-center gap-1.5" data-id="element-502">
                <div className="flex gap-0.5 text-gold" data-id="element-503">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold" data-id="element-504" />)}
                </div>
                <span className="text-white font-bold text-sm md:text-base" data-id="element-505">
                  4.9
                </span>
                <span className="text-textsecondary text-xs md:text-sm" data-id="element-506">
                  /5
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-textsecondary mt-0.5" data-id="element-507">
                <span className="text-electric font-semibold" data-id="element-508">+500</span>{' '}
                compradores
              </span>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-509">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum border border-electric/10 rounded-xl p-6 hover:border-electric/30 transition-colors machined-edge" data-id="element-510">
              <div className="flex items-center gap-4 mb-4" data-id="element-511">
                <div className={cn(`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-graphite font-bold text-lg`, 'bg-[#FFC107]')} data-id="element-512">
                  {t.initials}
                </div>
                <div data-id="element-513">
                  <div className="flex gap-1 mb-1" data-id="element-514">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-515" />)}
                  </div>
                  <div className="text-sm text-textsecondary" data-id="element-516">
                    <span className="text-white font-medium" data-id="element-517">{t.name}</span> •{' '}
                    {t.location}
                  </div>
                </div>
              </div>
              <p className="text-textsecondary italic" data-id="element-518">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}